import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from 'contexts/auth/auth_context';
import { toTitleCase } from 'common/utils/string.util';
import { FONT_SIZE } from 'utils/uteis';

const UserInfo: React.FC = () => {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignItems: { xs: 'center', sm: 'flex-end' },
        textAlign: { xs: 'center', sm: 'right' },
      }}
    >
      <Typography variant='h6' sx={{ color: '#FFFFFF' }}>
        Olá, {toTitleCase(String(user?.name))}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Roboto',
          fontWeight: 300,
          fontStyle: 'italic',
          fontSize: FONT_SIZE.medium,
          lineHeight: '12px',
          letterSpacing: '0.15px',
          color: '#FFFFFF',
        }}
      >
        Perfil: {toTitleCase(String(user?.permission?.profile?.name))}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Roboto',
          fontWeight: 300,
          fontStyle: 'italic',
          fontSize: FONT_SIZE.medium,
          lineHeight: '12px',
          letterSpacing: '0.15px',
          color: '#FFFFFF',
          marginY: 1,
        }}
      >
        Permissão: {toTitleCase(String(user?.permission?.name))}
      </Typography>
    </Box>
  );
};

export default UserInfo;
